// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getCategorias as listCategoriasAPI,
    getCategoria as getCategoriaAPI,
    addCategoria as addCategoriaAPI,
    updateCategoria as updateCategoriaAPI,
    deleteCategoria as deleteCategoriaAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { categoriasApiResponseError, categoriasApiResponseSuccess } from './actions';
import { CategoriasActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getCategoria({ payload: { id } }) {
    try {
        const response = yield call(getCategoriaAPI, id );
        const categoriaItem = response.data.data;
        yield put(categoriasApiResponseSuccess(CategoriasActionTypes.GET_CATEGORIA, categoriaItem));
    } catch (error) {
        yield put(categoriasApiResponseError(CategoriasActionTypes.GET_CATEGORIA, error));
    }
}

function* addCategoria({payload:categoria}){
    try{
        const response = yield call(addCategoriaAPI,{...categoria})
        const categoriaItem = response.data
        yield put(categoriasApiResponseSuccess(CategoriasActionTypes.ADD_CATEGORIA,categoriaItem))
    } catch(error){
        yield put(categoriasApiResponseError(CategoriasActionTypes.ADD_CATEGORIA,error))
    }
}

function* updateCategoria({payload:categoria}){
    try{
        const response = yield call(updateCategoriaAPI,{...categoria})
        const categoriaItem = response.data.data
        yield put(categoriasApiResponseSuccess(CategoriasActionTypes.UPDATE_CATEGORIA,categoriaItem))
    }catch(error){
        yield put(categoriasApiResponseError(CategoriasActionTypes.UPDATE_CATEGORIA,error))
    }
}
function* deleteCategoria({payload:{id}}){
    try{
        const response = yield call(deleteCategoriaAPI,id)
        const categoriaItem = response.data.id
        yield put(categoriasApiResponseSuccess(CategoriasActionTypes.DELETE_CATEGORIA,categoriaItem))
    }catch(error){
        yield put(categoriasApiResponseError(CategoriasActionTypes.DELETE_CATEGORIA,error))
    }
}

/**
 * List contactos
 */
function* listCategorias({payload:params}) {
    try {
        const response = yield call(listCategoriasAPI, { ...params });
        const listaCategorias = response.data.data;
        yield put(categoriasApiResponseSuccess(CategoriasActionTypes.LIST_CATEGORIAS, listaCategorias));
    } catch (error) {
        yield put(categoriasApiResponseError(CategoriasActionTypes.LIST_CATEGORIAS, error));
    }
}


export function* watchGetCategoria(): any {
    yield takeEvery(CategoriasActionTypes.GET_CATEGORIA, getCategoria);
}

export function* watchListCategorias(): any {
    yield takeEvery(CategoriasActionTypes.LIST_CATEGORIAS, listCategorias);
}

export function* watchAddCategoria():any{
    yield takeEvery(CategoriasActionTypes.ADD_CATEGORIA,addCategoria)
}
export function* watchUpdateCategoria():any{
    yield takeEvery(CategoriasActionTypes.UPDATE_CATEGORIA,updateCategoria)
}
export function* watchDeleteCategoria():any{
    yield takeEvery(CategoriasActionTypes.DELETE_CATEGORIA,deleteCategoria)
}


function* categoriasSaga(): any {
    yield all([
        fork(watchGetCategoria),
        fork(watchListCategorias),
        fork(watchAddCategoria),
        fork(watchUpdateCategoria),
        fork(watchDeleteCategoria),
    ]);
}

export default categoriasSaga;
